import { mapGetters } from 'vuex'

export default {
    data: function() {
        return {
            rules: {
                required: value => !!value || 'Debe ingresar un valor.',
                rounded: value =>
                    parseInt(value) % 10 === 0 ||
                    'Debe ingresar un valor multiplo de 10', // For cash payment
                notZero: value =>
                    parseInt(value) != 0 || 'No puede ingresar valor 0',
                validPayment: value =>
                    value <= 40 ||
                    'Pago no puede ser mayor que el total', // In case they are not paying with cash
                serial: value =>
                    value.length === 9 || 'Debe ingresar serial completo', // Serial number check payment
                validVoucher: value =>
                    value.length == 6 || 'Debe ingresar un número de 6 dígitos', // N° voucher transbank payment
                validTransNumber: value =>
                    value.length == 12 || 'Debe ingresar un número de 12 dígitos', // N° transfer in bank transfer payment
                accountNumber: value =>
                    value.length >= 12 || 'Debe ingresar  al menos 12 dígitos', // N° transfer in bank transfer payment
            },
        }
    },

    computed: {
        ...mapGetters('CustomerPaymentModule', {
            totalToPayCheck: 'totalToPay',
        }),
    },
}
